import React, { useState } from "react";
import {
  DialogContent,
  Grid,
  CardContent,
  Button,
  makeStyles,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { Formik } from "formik";
import {sendNotificationApi} from '../api/callingInterface'
import { toastError, toastSuccess} from "shared/utils";

const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 650,
    },

    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }));

const CallingInterface = (props) => {
    const { visible, handleDialogClose} = props;
    const classes = useStyles();
    const [spinning, setSpinning] = useState(false);
    const [radioButtonValue,setRadioButtonValue] = useState('')

    const handleClose = (_) => {
        handleDialogClose(false);
      };    
  const onClickSendNotification = (values) =>{
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))  : "";

    let data = {
      "customer_number": props?.mobileNumber,
      "call_type": "fresh_call",
      "fresh_call": radioButtonValue,
      "subuser_reference_number": user?.subuser_reference_number,
      "customer_name": props?.userData?.full_name,
      "user_id": props?.userData?.user_id,
      "user_reference_number" :props?.userData?.user_reference_number 
    }
    if(props?.data != "userview"){
      delete data.customer_name
      delete data.user_id
      delete data.user_reference_number
    }
    
    sendNotificationApi(data)
    .then((res) =>{
      if(res?.message == "Success"){
        toastSuccess(res?.message)
        handleClose();
        props.resetFunc(res?.message);
      }
    }).catch((res) => {
      toastError(res.message)
    });

  }

  const RadioButtonHandle =(e)=>{
    setRadioButtonValue(e.target.value)
  }

  return (
    <Spin spinning={spinning}>
        <Formik
            initialValues={{
            status: "",
            search: "",
            mobile_number:""
            }}
      >
        {({ values, touched, setFieldValue }) => (
        <>

    <KisshtDialog
      title=" Call Interface" 
      maxWidth={"sm"}     
      open={visible}
      handleClose={handleClose}
    >
      <DialogContent>
        <Card className={classes.card}>
          <CardContent>
            <Grid container>
                <div style={{width:'100%',height:'1px',backgroundColor:'#000'}}>

                    </div>
                <Grid container flex-direction="row" style={{paddingTop:'15px',paddingBottom:'15px'}}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                    <p style={{padding:'10px 0'}}> Is it a fresh call ?</p>
                    <Grid item>
                    <RadioGroup
                          onChange={(e)=>RadioButtonHandle(e)}
                          style={{ textAlign: "center" }}
                        >
                          <FormControlLabel
                            value="fresh_call"
                            name="Yes"
                            control={<Radio color="primary" />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="others"
                            name="No"
                            control={<Radio color="primary" />}
                            label="No"
                          />
                        </RadioGroup>
                    </Grid>
                    <Grid container style={{flexDirection:"row"}}> 
                        <Grid item >
                             <AddIcCallIcon style={{cursor: "pointer", fontSize: "18px"}} color="primary"/>
                        </Grid>
                        <Grid item >
                          <span style={{marginLeft:'10px'}}>{props?.mobileNumber}</span>
                        </Grid>
                    </Grid>                    
                    
                    </Grid>
                </Grid>
                <div style={{width:'100%',height:'1px',backgroundColor:'#000'}}>

                </div>
                <div  container style={{display:'flex',width:'100%',justifyContent:'end'}}> 
                    <Grid style={{padding:'10px'}} item className={classes.root}>
                      <Button
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        // color="primary"
                        style={{background:'rgb(255, 73, 97)'}}
                        size="medium"
                        type="submit"
                        onClick={() =>handleClose()}
                      >
                        Close
                    </Button>
                    </Grid>
                    <Grid style={{padding:'10px'}} item className={classes.root}>
                      <Button
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        // color="primary"
                        style={{backgroundColor:'rgb(81 187 237)'}}
                        size="medium"
                        type="submit"
                        onClick={() =>onClickSendNotification()}
                      >
                        Dial
                    </Button>
                    </Grid>
                    </div>
            </Grid>
         
          </CardContent>
        </Card>
      </DialogContent>
    </KisshtDialog>
    </>
      )}
      </Formik>
  </Spin>
  )
 
};

export default CallingInterface;
